<div class="container mt-5">
    <div class="row column-container align-items-center justify-content-center">

        <!-- Bal oldal: két konténer egymás alatt -->
        <div class="col-6 d-flex flex-column">
            <div class="left-container">
                <div class="bvmt-info alert alert-primary d-flex justify-content-center align-items-center mb-0">
                    <b>{{subType}} </b>
                </div>
                <div class="bvmt-refimg-container">
                    <img src="{{srcPath}}">
                </div>
            </div>
            <div class="left-container">
                <div class="bvmt-drawingContainer mb-3" id="xy-1" freehand [interactive]="false">
                </div>
            </div>
        </div>

        <!-- Jobb oldal: egy konténer teljes magasságban -->
        <div class="col-3">
            <div class="full-height ">
                <dx-check-box [(value)]="wrResult.numbers1[0]" text="{{ 'Game.BvrtErr0' | translate:locale.language }}">
                </dx-check-box><br>
                <dx-check-box [(value)]="wrResult.numbers1[1]" text="{{ 'Game.BvrtErr1' | translate:locale.language }}">
                </dx-check-box><br>
                <dx-check-box [(value)]="wrResult.numbers1[2]" text="{{ 'Game.BvrtErr2' | translate:locale.language }}">
                </dx-check-box><br>
                <dx-check-box [(value)]="wrResult.numbers1[3]" text="{{ 'Game.BvrtErr3' | translate:locale.language }}">
                </dx-check-box><br>
                <dx-check-box [(value)]="wrResult.numbers1[4]" text="{{ 'Game.BvrtErr4' | translate:locale.language }}">
                </dx-check-box><br>
                <dx-check-box [(value)]="wrResult.numbers1[5]" text="{{ 'Game.BvrtErr5' | translate:locale.language }}">
                </dx-check-box><br>
                <dx-check-box [(value)]="wrResult.numbers1[6]" text="{{ 'Game.BvrtErr6' | translate:locale.language }}">
                </dx-check-box><br>
                <dx-check-box [(value)]="wrResult.numbers1[7]" text="{{ 'Game.BvrtErr7' | translate:locale.language }}">
                </dx-check-box><br>
                <dx-check-box [(value)]="wrResult.numbers1[8]" text="{{ 'Game.BvrtErr8' | translate:locale.language }}">
                </dx-check-box><br><br>
                <div class="mb-3">
                    <div class="form-label">{{ 'Core.EntityNote' | translate:locale.language }}</div>
                    <dx-text-box stylingMode="filled" [(value)]="wrResult.words[2]">
                    </dx-text-box>
                </div>

            </div>
        </div>

    </div>
</div>

<div *ngIf="false" class="d-flex flex-column align-items-center">

    <div class="bvmt-info alert alert-primary d-flex justify-content-center align-items-center mb-0">
        <b>{{subType}} </b>
    </div>
    <div class="bvmt-refimg-container">
        <img src="{{srcPath}}">
    </div>
    <div class="bvmt-drawingContainer mb-3" id="xy-1" freehand [interactive]="false">
    </div>
    <table class="table table-bordered text-center bg-white">
        <tbody>
            <tr>
                <td>
                    <dx-check-box [(value)]="wrResult.numbers1[0]"
                        text="{{ 'Game.BvrtErr0' | translate:locale.language }}">
                    </dx-check-box>
                </td>
            </tr>
            <tr>
                <td>
                    <dx-check-box [(value)]="wrResult.numbers1[1]"
                        text="{{ 'Game.BvrtErr1' | translate:locale.language }}">
                    </dx-check-box>
                </td>
            </tr>
            <tr>
                <td>
                    <dx-check-box [(value)]="wrResult.numbers1[2]"
                        text="{{ 'Game.BvrtErr2' | translate:locale.language }}">
                    </dx-check-box>
                </td>
            </tr>
            <tr>
                <td>
                    <dx-check-box [(value)]="wrResult.numbers1[3]"
                        text="{{ 'Game.BvrtErr3' | translate:locale.language }}">
                    </dx-check-box>
                </td>
            </tr>
            <tr>
                <td>
                    <dx-check-box [(value)]="wrResult.numbers1[4]"
                        text="{{ 'Game.BvrtErr4' | translate:locale.language }}">
                    </dx-check-box>
                </td>
            </tr>
            <tr>
                <td>
                    <dx-check-box [(value)]="wrResult.numbers1[5]"
                        text="{{ 'Game.BvrtErr5' | translate:locale.language }}">
                    </dx-check-box>
                </td>
            </tr>
            <tr>
                <td>
                    <dx-check-box [(value)]="wrResult.numbers1[6]"
                        text="{{ 'Game.BvrtErr6' | translate:locale.language }}">
                    </dx-check-box>
                </td>
            </tr>
            <tr>
                <td>
                    <dx-check-box [(value)]="wrResult.numbers1[7]"
                        text="{{ 'Game.BvrtErr7' | translate:locale.language }}">
                    </dx-check-box>
                </td>
            </tr>
            <tr>
                <td>
                    <dx-check-box [(value)]="wrResult.numbers1[8]"
                        text="{{ 'Game.BvrtErr8' | translate:locale.language }}">
                    </dx-check-box>
                </td>
            </tr>
        </tbody>
    </table>

</div>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [position]="{ of: '#reg' }" [(visible)]="loading"
    [showIndicator]="true" [showPane]="true" [shading]="true" [hideOnOutsideClick]="false" (onShown)="onShown()">
</dx-load-panel>